<template>
  <section class="sc-location">
    <div class="sc-location-inner">
      <h2 class="sc-location-title">
        Choose a Location
      </h2>
      <div class="sc-location-grid">
        <a
          v-for="loc in locations"
          :key="loc.name"
          :href="loc.url"
          target="_self"
          class="sc-loc-card"
          :class="{ 'is-active': loc.active }"
        >
          <span class="sc-loc-name">{{ loc.name }}</span>
          <span class="sc-loc-area">{{ loc.area }}</span>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SummerCampLocation',
  data() {
    return {
      locations: [
        {
          name: 'Campbell', area: '(South Bay)', url: 'https://www.jointhinkzone.com/Campell/summercamp', active: true,
        },
        {
          name: 'Cupertino', area: '(South Bay)', url: 'https://www.jointhinkzone.com/Cupertino/summercamp', active: false,
        },
        {
          name: 'Fremont', area: '(East Bay)', url: 'https://www.jointhinkzone.com/Fremont/summercamp', active: false,
        },
        {
          name: 'Millbrae', area: '(Peninsula)', url: 'https://www.jointhinkzone.com/Millbrae/summercamp', active: false,
        },
        {
          name: 'Milpitas', area: '(South Bay)', url: 'https://www.jointhinkzone.com/Milpitas/summercamp', active: false,
        },
        {
          name: 'Redwood City', area: '(Peninsula)', url: 'https://www.jointhinkzone.com/RedwoodCity/summercamp', active: false,
        },
        {
          name: 'Sunnyvale', area: '(South Bay)', url: 'https://www.jointhinkzone.com/Sunnyvale/summercamp', active: false,
        },
        {
          name: 'Union City', area: '(East Bay)', url: 'https://www.jointhinkzone.com/UnionCity/summercamp', active: false,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.sc-location {
  padding-bottom: 100px;
  background: #fff;
  font-family: 'Roboto-Flex', sans-serif;

  .sc-location-inner {
    max-width: 1280px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 44px;
  }

  .sc-location-title {
    font-size: 48px;
    font-weight: 600;
    line-height: 48px;
    color: #44454c;
    text-align: center;
    margin: 0;
    font-family: 'Roboto-Flex', sans-serif;
  }

  .sc-location-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px 26px;
  }

  .sc-loc-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 152px;
    background: #FFFFFF;
    border-radius: 10px;
    border: 2px solid #D1C6C5;
    color: #8B716E;
    text-decoration: none;
    transition: box-shadow 0.2s ease, border-color 0.2s ease;
    cursor: pointer;

    .sc-loc-name {
      font-size: 22px;
      font-weight: 700;
      line-height: 30px;
      font-family: 'Roboto-Flex', sans-serif;
    }

    &:hover {
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
      border-color: var(--txt-color-link);
      background: #fff1f1;
      color: var(--txt-color-link);
    }

    .sc-loc-area {
      font-size: 18px;
      font-weight: 500;
      line-height: 26px;
      font-family: 'Roboto-Flex', sans-serif;
    }
  }
}
</style>
